import { Skeleton, styled } from '@mui/material'

export const StyledSkeleton = styled(Skeleton)({
  borderRadius: 4,
  transform: 'scale(1, 0.8)',
})
